import { useProjectParams } from '@hooks/useProjectParams';
import { RequestStatus } from 'features/request/requestSlice';
import { useProjectData } from 'hooks/useProjectData';
import { useSendGpnAnalyticsEvent } from 'hooks/useSendGpnAnalyticsEvent';
import { ProjectPageLayout } from 'pages/Project/Common/Layouts/ProjectPageLayout';
import { Loader } from 'uikit';

import { useEffect, useMemo } from 'react';

import { ContractToolbar } from '../ContractToolbar';
import { ContractModal } from '../ContractUpload/ContractModal';
import { useContractData } from '../hooks/useContractData';
import { parseContractData } from '../utils';

import { ContractReadForm } from './ContractReadForm';

export const ContractRead = () => {
    const { id: projectId, methodology } = useProjectParams();

    const { sendGpnAnalyticsEvent } = useSendGpnAnalyticsEvent();

    const { projectData } = useProjectData(projectId);

    const [getContractData, getContractStatus, , makeContractDataRequest] = useContractData(projectData?.contractId);

    useEffect(() => {
        if (projectData && getContractStatus === RequestStatus.SUCCESS) {
            sendGpnAnalyticsEvent({
                componentId: 'rim_contract page_onloaded',
                constaeventtype: 'undefined',
                component: 'OTHER',
                projectId: projectData.uniqueId,
                methodology: projectData.methodology,
                projectName: projectData.name,
                projectType: projectData.contractType,
                projectDO: projectData.subsidiary?.name,
                sendOnce: true,
            });
        }
    }, [getContractStatus, projectData, sendGpnAnalyticsEvent]);

    const breadCrumbsItems = useMemo(
        () => [
            {
                label: projectData?.name,
                href: `/projects/${methodology}/${projectId}`,
            },
        ],
        [methodology, projectData?.name, projectId],
    );

    const defaultValues = useMemo(() => parseContractData(getContractData), [getContractData]);

    return (
        <ProjectPageLayout
            isHeaderCollapsable
            title="Договор"
            breadCrumbsItems={breadCrumbsItems}
            headerBottom={
                <ContractToolbar
                    contractData={getContractData}
                    projectId={projectId}
                    statusContract={getContractData?.status}
                    projectData={projectData}
                />
            }
        >
            {projectData?.contractId !== null ? (
                <>
                    {getContractStatus === RequestStatus.SUCCESS && (
                        <ContractReadForm
                            defaultValues={defaultValues}
                            makeContractDataRequest={makeContractDataRequest}
                            data={getContractData}
                        />
                    )}
                    {getContractStatus === RequestStatus.FETCHING && <Loader />}
                </>
            ) : (
                <ContractModal projectId={projectId} />
            )}
        </ProjectPageLayout>
    );
};

ContractRead.displayName = 'ContractRead';
